<template>
  <div>
    <card type="chart">
      <template slot="header">
        <div class="row">
          <div class="col-sm-12">
            <h2 class="card-title d-inline" title="U.S. Vaccination Tracker">
              U.S. Vaccination Tracker
            </h2>
            <el-tooltip
              content="Vaccination across the US."
              effect="dark"
              :open-delay="300"
              placement="top"
            >
              <base-button type="link">
                <i
                  class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                ></i>
              </base-button>
            </el-tooltip>
          </div>
        </div>
      </template>
      <div>
        <div
          id="containervaccin"
          style="
            height: 380px;
            min-width: 300px;
            max-width: 900px;
            margin: 0 auto;
          "
        ></div>
        <div class="text-center mainscorebox" v-show="renderedMap">
          <section class="smallbox pt-3 legend-width">
            <span class="pr-1 pt-1 text-white"><b>Low</b></span>
            <div
              v-for="(color, index) in mapColor"
              class="smallsection"
              :key="color"
            >
              <div
                :style="'background-color:' + color"
                style="height: 28px"
                :class="'border' + index"
              ></div>
            </div>
            <span class="pl-1 pt-1 text-white"><b>High</b></span>
          </section>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import * as chartConfigsH from "@/components/Charts/HighchartConfig";
import * as chartConfigs from "@/components/Charts/config";
import axios from "axios";
import moment from "moment";
import lodash from "lodash";
const options = chartConfigsH.config;
const removeState = chartConfigs.removeState;
export default {
  data() {
    return {
      vaccinData: [],
      renderedTable: false,
      renderedMap: false,
      mapOptions: {},
      mapColor: ["#D0E0FC", "#A0C2FA", "#71A3F7", "#4285F4", "#3366D6"],
    };
  },
  components: {},
  mounted() {
    var self = this;
    this.setTheme();
    axios
      .get(process.env.VUE_APP_API_URL + "/covidactnow/vaccinemap")
      .then((response) => {
        var origianlData = response.data
          .filter((value) => !removeState.includes(value.state.trim()))
          .map((o) => {
            o.state = o.state.trim();
            return o;
          });
        var data = [];
        // Set drilldown pointers
        const max = origianlData.reduce(function (prev, current) {
          return parseFloat(prev.vaccinations_completed) >
            parseFloat(current.vaccinations_completed)
            ? prev
            : current;
        });
        const min = origianlData.reduce(function (prev, current) {
          return parseFloat(prev.vaccinations_completed) <
            parseFloat(current.vaccinations_completed)
            ? prev
            : current;
        });
        console.log(max, min);
        for (var i = 0; i < origianlData.length; i++) {
          var dataset = origianlData[i];
          var temp = {};
          temp.name = dataset.state.trim();
          temp.code = chartConfigs.states_hash[dataset.state.trim()];
          //temp.color = "#ff0000";
          temp.value = dataset.vaccinations_completed
            ? parseInt(dataset.vaccinations_completed)
            : 0;
          temp.vaccines_distributed = dataset.vaccines_distributed
            ? this.format(dataset.vaccines_distributed)
            : "";
          temp.vaccinations_initiated = dataset.vaccinations_initiated
            ? this.format(dataset.vaccinations_initiated)
            : "";
          temp.vaccinations_completed = dataset.vaccinations_completed
            ? this.format(dataset.vaccinations_completed)
            : "";
          temp.vaccinations_completed_percent_population = dataset.vaccinations_completed_percent_population
            ? parseFloat(
                dataset.vaccinations_completed_percent_population
              ).toFixed(0) + "%"
            : "";
          temp.vaccines_distributed_per_100k = dataset.vaccines_distributed_per_100k
            ? this.format(dataset.vaccines_distributed_per_100k)
            : "";
          data.push(temp);
        }
        self.vaccinData = [...data];
        self.renderMap(
          data,
          parseInt(min.vaccinations_completed),
          parseInt(max.vaccinations_completed)
        );
      });
  },
  methods: {
    format(txt) {
      var num_parts = txt.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //num_parts.join(".");
      return num_parts[0];
    },
    renderMap(data, valuesMin, valuesMax) {
      var self = this;
      // Instanciate the map.mapChart('world-map',
      Highcharts.mapChart("containervaccin", {
        chart: {
          events: {},
          map: "countries/us/us-all",
          scrollablePlotArea: {
            minWidth: 500,
            scrollPositionX: 1,
            opacity: 0,
          },
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        plotOptions: {
          map: {
            states: {
              hover: {
                enabled: false,
                color: "#EEDD66",
              },
            },
          },
        },
        colorAxis: {
          minColor: "#D0E0FC",
          maxColor: "#3366D6",
          min: valuesMin,
          max: valuesMax,
          type: "linear",
        },
        series: [
          {
            data: data,
            joinBy: ["postal-code", "code"],
            dataLabels: {
              enabled: false,
              pointFormat: "{point.name}",
            },
            tooltip: {
              useHTML: true,
              headerFormat: "<b>{point.name}</b><br>",
              pointFormat:
                "<b>{point.name}</b>" +
                "<br/>Vaccines Distributed: {point.vaccines_distributed}" +
                "<br/>Vaccinations Initiated: {point.vaccinations_initiated}" +
                "<br/>Vaccinations Completed: {point.vaccinations_completed}" +
                "<br/>Vaccination Completed for Percent Poplulation: {point.vaccinations_completed_percent_population}" +
                "<br/>Vaccinations Distributed per 100k: {point.vaccines_distributed_per_100k}",
            },
          },
        ],
      });
      console.log("==", JSON.stringify(data));
      console.log("==", valuesMin, valuesMax);
      self.renderedMap = true;
    },
    setTheme() {
      Highcharts.theme = options;
      // Apply the theme
      Highcharts.setOptions(Highcharts.theme);
    },
  },
};
</script>
 <style scoped>
.scorebox {
  padding: 5px 30px;
}
.legend-width {
  width: 200px;
}
@media (min-width: 961px) {
  .mainscorebox {
    padding-top: 20px;
    width: 90%;
    margin: 0 auto;
  }
}
@media (min-width: 320px) and (max-width: 768px) {
  .legend-width {
    width: 180px !important;
  }
}
.text-section {
  margin-bottom: 10px;
}
.smallbox {
  display: flex;
  margin: 0 auto;
}
.smallsection {
  flex-grow: 1;
}
.border0 {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}
.border4 {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
</style>
